const mutations = {
  getPaxelBigCustomers: (state, paxel_big_customer) => {
    state.paxel_big_customer = paxel_big_customer;
  },
  getPaxelBigCustomer: (state, paxel_big_customer_id) => {
    state.paxel_big_customer_id = paxel_big_customer_id;
  },
  postPaxelBigCustomer: (state, new_paxel_big_customer) => {
    state.paxel_big_customer.push(new_paxel_big_customer);
  },
  putPaxelBigCustomer: (state, payload) => {
    state.paxel_big_customer = state.paxel_big_customer.map((paxel_big_customer) => {
      if (paxel_big_customer.paxel_big_customer_id === payload.id) {
        return Object.assign({}, paxel_big_customer, payload.paxel_big_customerData);
      }
      return paxel_big_customer;
    });
  },
  delPaxelBigCustomer(state, id) {
    const index = state.paxel_big_customer.findIndex(paxel_big_customer => paxel_big_customer.paxel_big_customer_id == id);
    state.paxel_big_customer.splice(index, 1);
  },
};

export default mutations;
